import * as Actions from '../../../../redux/actions'

import {
    TimesIcon,
} from '../../Common/SVGBank'

import DatePicker from "react-datepicker"
import React, { useState, useEffect, useCallback } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import { getAirportsListThunk } from '../../FlightsPage/services/Flights.thunks'
import moment from 'moment'
import { useLocation } from 'react-router-dom';
import { calculatePercentageDifference, getDates, getFlightsByDate } from '../../FlightsPage/services/flights.services'
import { setShowFlightCalendar } from '../services/Flights.slice'
import CalendarPriceView from './FlightCalendarPriceView'


const FlightCalendar_ = ({ app_menu_height, departingFlight, returningFlight, is_mobile, getAirportList }) => {
    const dispatch = useDispatch()
    const location = useLocation()

    const [startDate, setStartDate] = useState(null)
    const [endDate, setEndDate] = useState(null)
    const [cachedPrices, setCachedPrices] = useState([])
    const [searching, setSearching] = useState(false)

    const [airportFrom, setAirportFrom] = useState()
    const [airportTo, setAirportTo] = useState()

    const showFlightCalendar = useSelector(state => state.Flights.showFlightCalendar)
    const cabinClass = useSelector(state => state.Flights.flightData.cabinClass)
    const flightMode = useSelector(state => state.Flights.flightData.flightMode)
    const numberAdult = useSelector(state => state.Flights.flightData.numberAdult)
    const numberChild = useSelector(state => state.Flights.flightData.numberChild)
    const flights = useSelector(state => state.Flights.flightData.flights)
    const currency = useSelector(state => state.Setting.currency)
    const selectedCurrency = useSelector(state => state.Setting.currency.selected.shortCode)
    const fullCurrency = selectedCurrency ? selectedCurrency.toUpperCase() : "CAD"

    const departingDate = departingFlight && moment(departingFlight.departureDateFormat).toDate()

    const onChange = (dates) => {
        if (Array.isArray(dates)) {
            const [start, end] = dates
            setStartDate(start)
            setEndDate(end)
        }
    }




    const closeCalendar = () => {
        dispatch(setShowFlightCalendar(false))
    }
    const priceData = {
        '2022-11-03': { price: 1234, delta: 0 },
        '2022-11-06': { price: 1000, delta: -234 },
        // ...
    }

    const today = new Date();
    const oneYearLater = new Date(today.getFullYear() + 1, today.getMonth(), today.getDate());


    if (!showFlightCalendar) return null

    return (
        <div style={{
            position: 'fixed',
            top: `${app_menu_height}px`,
            left: '15.6%',
            right: 0,
            backgroundColor: 'white',
            zIndex: 1300,
            boxShadow: "0px 3px 6px #00000029",
            width: '70%',
            height: 600
        }}>
            <div style={{
                position: 'absolute',
                top: 20,
                right: 10,
                cursor: 'pointer',
            }} onClick={closeCalendar}>
                <TimesIcon fill="#EEEEEE" width={25} height={25} />
            </div>


            <div className=''>
                <CalendarPriceView priceData={priceData}
                    minDate={today}
                    maxDate={oneYearLater} />
            </div>

        </div>
    )
}

const mapStateToProps = (state) => ({
    lang: state.Setting.lang,
    is_mobile: state.Setting.is_mobile,
    app_menu_height: state.Setting.appMenu.app_menu_height,
})

const mapDispatchToProps = {
    getAirportList: Actions.getAirportList,
}

const FlightCalendar = connect(mapStateToProps, mapDispatchToProps)(FlightCalendar_)
export default FlightCalendar
